(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-nameplate"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('product-nameplate')){
    customElements.define('product-nameplate',class extends HTMLElement{
      connectedCallback(){
        if(this.initialized)return;
        this.initialized=true;
        const noText=this.querySelector('[data-np-no-text]');
        const status=this.querySelector('[data-np-status]');
        const name=this.querySelector('[data-np-name]');
        const title=this.querySelector('[data-np-title]');
        const font=this.querySelector('[data-np-font]');
        const namePreview=this.querySelector('[data-np-name-preview]');
        const titlePreview=this.querySelector('[data-np-title-preview]');
        const preview=this.querySelector('[data-np-preview]');
        const plate=this.querySelector('[data-np-plate]');
        const families={'Montserrat':'"Montserrat",sans-serif','Instrument Sans':'"Instrument Sans",sans-serif','Lora':'"Lora",serif','Playfair Display':'"Playfair Display",serif','Cinzel':'"Cinzel",serif','Marcellus':'"Marcellus",serif','Great Vibes':'"Great Vibes",cursive','Allura':'"Allura",cursive'};
        const loadFont=family=>{
          if(!families[family]||family==='Montserrat'||family==='Instrument Sans')return;
          const key='np-font-'+family.replace(/ /g,'-');
          if(document.getElementById(key))return;
          const link=document.createElement('link');link.id=key;link.rel='stylesheet';
          const weight=family==='Allura'||family==='Great Vibes'||family==='Marcellus'?'':':wght@500';
          link.href='https://fonts.googleapis.com/css2?family='+encodeURIComponent(family).replace(/%20/g,'+')+weight+'&display=swap';
          document.head.append(link);
        };
        const sync=()=>{
          const blank=noText.checked;
          this.classList.toggle('is-no-text',blank);
          name.required=!blank;
          name.disabled=blank;
          title.disabled=blank;
          font.disabled=blank;
          this.querySelectorAll('input[type=radio]').forEach((radio)=>{radio.disabled=blank});
          status.value=blank?'Yazısız':'Kişiselleştirildi';
          const nameText=name.value.trim();
          const titleText=title.value.trim();
          name.setCustomValidity(!blank&&name.value&&!nameText?'İsimliğe yazılacak adı girin.':'');
          namePreview.textContent=nameText||'Adınız Soyadınız';
          titlePreview.textContent=titleText;
          titlePreview.hidden=!titleText;
          if(!blank)loadFont(font.value);
          namePreview.style.fontFamily=families[font.value]||families.Montserrat;
          const finish=this.querySelector('input[type=radio]:checked');
          plate.dataset.finish=finish&&finish.value==='Gümüş'?'silver':'gold';
          preview.setAttribute('aria-label','İsimlik önizlemesi: '+namePreview.textContent+(titleText?', '+titleText:''));
        };
        this.addEventListener('input',sync);
        this.addEventListener('change',sync);
        this.closest('form')?.addEventListener('reset',()=>requestAnimationFrame(sync));
        sync();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
